import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import TaxFormPdfInterface from './interfaces/TaxFormPdfInterface.interface';

export interface GenerateSignLinkData {
	custodian_request_id: number;
	application_id: number;
	type: 'tax-form' | 'w8-ben' | 'w9';
}

export type GenerateSignLinkResponse = {
	status: boolean;
	request_to_sign: TaxFormPdfInterface;
};

const generateSignLink = configRequest<GenerateSignLinkResponse, GenerateSignLinkData>({
	requestPrefix: 'applications/generateSignLink',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.GENERATE_SIGN_LINK(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export const generateSignLinkValidation = configRequest<GenerateSignLinkResponse, GenerateSignLinkData>({
	requestPrefix: 'applications/generateSignLinkValidation',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.GENERATE_SIGN_LINK(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			only_validate: true,
		},
	}),
});

export default generateSignLink;
